import axios from 'axios';
import { API_BASE_URL } from '../config/api';

export interface SupportRequest {
  id: number;
  user_id: number;
  request_type: string;
  subject: string;
  description: string;
  status: string;
  priority: string;
  response?: string;
  created_at: string;
  updated_at: string;
  resolved_at?: string;
  resolved_by?: number;
}

export interface CreateSupportRequest {
  request_type: string;
  subject: string;
  description: string;
  priority?: string;
}

export const supportApi = {
  // Create a new support request
  createRequest: async (data: CreateSupportRequest): Promise<SupportRequest> => {
    const token = localStorage.getItem('auth_token');
    const response = await axios.post(`${API_BASE_URL}/support/`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },

  // Get current user's support requests
  getMyRequests: async (): Promise<SupportRequest[]> => {
    const token = localStorage.getItem('auth_token');
    const response = await axios.get(`${API_BASE_URL}/support/me`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return Array.isArray(response.data) ? response.data : [];
  },

  // Get a specific request
  getRequest: async (requestId: number): Promise<SupportRequest> => {
    const token = localStorage.getItem('auth_token');
    const response = await axios.get(`${API_BASE_URL}/support/${requestId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  },
};

export default supportApi;
